import React from "react";
import {Row, Col, Menu, Button, Space, Skeleton} from "antd";
import { LinkedinOutlined, FacebookOutlined, InstagramOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {Team} from "interfaces";
import data from "./data";

interface Props {
    detail : Team | undefined,
    team : Team[],
    selected : string,
    isLoading : boolean
}

const Detail : React.FC<Props> = ({detail, team = [], selected, isLoading}) => {
    return (
        <section className={"main-detail"}>
            <div className={"public-container"}>
                <Row gutter={[100, 50]}>
                    <Col md={17} sm={24} xs={24}>
                        <div className={"card"}>
                            <div className={"card-cover"}>
                                <div className={"card-list"}>
                                    {
                                        isLoading
                                            ? <Skeleton.Avatar size={500} shape={"square"} active={true} />
                                            : <img src={detail?.image?.url} alt={detail?.name} />
                                    }
                                </div>
                            </div>
                            <div className={"card-text"}>
                                <h4>{detail?.name}</h4>
                                <p>{detail?.position}</p>
                            </div>
                        </div>
                        <div className={"about"}>
                            {
                                isLoading
                                    ? <Skeleton active={true} paragraph={{rows : 2}} />
                                    : <>
                                        <h2>{data.detail.id.about}</h2>
                                        <p>{detail?.aboutMe}</p>
                                    </>
                            }
                        </div>
                        <div className={"skill"}>
                            {
                                isLoading
                                    ? <Skeleton active={true} paragraph={{rows : 2}} />
                                    : <>
                                        <h2>{data.detail.id.skill}</h2>
                                        <p>{detail?.skill}</p>
                                    </>
                            }
                        </div>
                        <div className={"say"}>
                            {
                                isLoading
                                    ? <Skeleton active={true} />
                                    : <>
                                        <h2>{data.detail.id.say}</h2>
                                        <Space size={"middle"} className={"space"}>
                                            <a
                                                href={detail?.linkedin}
                                                target={"_blank"}
                                                rel={"noreferrer"}
                                            >
                                                <LinkedinOutlined />
                                            </a>
                                            <a
                                                href={detail?.facebook}
                                                target={"_blank"}
                                                rel={"noreferrer"}
                                            >
                                                <FacebookOutlined />
                                            </a>
                                            <a
                                                href={detail?.instagram}
                                                target={"_blank"}
                                                rel={"noreferrer"}
                                            >
                                                <InstagramOutlined />
                                            </a>
                                        </Space>
                                        <br/>
                                        <Button
                                            size={"large"}
                                            type={"primary"}
                                            href={detail?.externalLink}
                                            target={"_blank"}
                                        >
                                            Kenal Saya Lebih Lanjut
                                        </Button>
                                    </>
                            }
                        </div>
                    </Col>
                    <Col md={7} sm={24} xs={24}>
                        <div className={"menu"}>
                            <h2>{data.detail.id.team}</h2>
                            <Menu selectedKeys={[selected]}>
                                {
                                    (isLoading ? new Array(13).fill({}, 0, 13) : team)
                                    .map((item, x) => (
                                        <Menu.Item key={item.nickname || x}>
                                            {
                                                isLoading
                                                    ? <Skeleton active={true} paragraph={{rows : 0}} />
                                                    : <Link to={`/team/${item.nickname}`}>
                                                        {item.name}
                                                    </Link>
                                            }
                                        </Menu.Item>
                                    ))
                                }
                            </Menu>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default React.memo(Detail)